import script from "./WaterPanelUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaterPanelUI.vue?vue&type=script&setup=true&lang=ts"

import "./WaterPanelUI.vue?vue&type=style&index=0&id=3b3a01da&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3a01da"]])

export default __exports__